module.exports = __webpack_public_path__ + "static/media/jobbeurs_home1_resize.aabc73c8.jpg";